import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {ActivityI, RedirectI, TaskI, TaskStatus} from "../../../../infrastructure/interfaces/task.interface";

@Component({
  selector: 'app-cost-manager',
  templateUrl: './cost-manager.component.html',
  styleUrls: ['./cost-manager.component.scss']
})
export class CostManagerComponent  implements OnChanges {

  taskStatus = TaskStatus

  @Input() activityData: ActivityI | null = null;
  @Input() taskData: TaskI | null = null;
  @Output() saveData: EventEmitter<any> = new EventEmitter<any>();

  constructor() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("Redirector Changes =>", changes);

    if (changes["taskData"]){
      this.taskData = changes["taskData"]["currentValue"]
    }

    if (changes["activityData"]){

      this.activityData = changes["activityData"]["currentValue"]

    }
  }

  onSaveData(event: any) {
    console.log("Appointment data => ", event);
    this.saveData.emit(event);
  }
}
